module.exports = __webpack_public_path__ + "img/eyebrow-1.b7f64caf.svg";